import { TabidooTablePage } from '@/components/vyroba/TabidooTablePage';

/**
 * Databáze norem jednotlivých švadlenek — zrcadlo Tabidoo tabulky
 * „databazeNoremJednotlivychSvadlenek". Říká, jak rychle která švadlenka šije
 * který typ produktu (norma v %), takže z ní půjde počítat čas na míru místo
 * paušální normy kategorie.
 */
export function DatabazeNoremPage() {
  return (
    <TabidooTablePage
      table="normy"
      storagePrefix="normy"
      title="Normy švadlenek"
      subtitle="Zrcadlo z Tabidoo. Kolik procent normy zvládá která švadlenka u které kategorie produktu. Klikni na řádek pro detail a editaci."
      createLabel="+ Nový záznam"
    />
  );
}
